import React from 'react';
import AddHubForm from '../forms/add-hub';

export default function(props){
  return <React.Fragment>
    <AddHubForm {...props} />
  </React.Fragment>;
}